import sourceMigrationRedux from 'Modules/importAccount/views/main/.components/sourceMigration/redux/reducer';
import newMigrationRedux from 'Modules/importAccount/views/main/.components/newMigration/redux/reducer';
import exceptionDetailsRedux from 'Modules/importAccount/views/main/.components/exceptionDetails/redux/reducer';
//export redux objects
export default {
    sourceMigrationRedux,
    newMigrationRedux,
    exceptionDetailsRedux
};